import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import ReceptionForm from "./reception-form";
import LoadReviewForm from "./load-review-form";
import CubiscanForm from "./cubiscan-form";
import LocationsForm from "./locations-form";

function FormsView({ master, loading, setLoading }) {
  const [activeForm, setActiveForm] = useState(null);
  const [selectedSubproduct, setSelectedSubproduct] = useState(null);
  const [receptionFormData, setReceptionFormData] = useState(null);
  const [isLoadingReceptionData, setIsLoadingReceptionData] = useState(false);

  const isConsolidated = Array.isArray(master?.data) && master.data.length > 0;

  const safeValue = (value, defaultValue = null) => {
    return value !== null && value !== undefined ? value : defaultValue;
  };

  const loadReceptionData = async (houseId = null) => {
    try {
      setIsLoadingReceptionData(true);
      const masterId = master.resp?.id || master.resp?.master_id;

      let url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/reception_form?master_id=${masterId}`;

      if (houseId) {
        url += `&house_id=${houseId}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.code === 1) {
        setReceptionFormData(response.data.data);
        return response.data.data;
      } else {
        console.error("Error en respuesta de API:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error al cargar formulario:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudieron cargar los datos del formulario de recepción",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return null;
    } finally {
      setIsLoadingReceptionData(false);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      // Solo cargar si no hay datos de recepción aún
      if (!receptionFormData) {
        await loadReceptionData();

        // Si no hay subproductos consolidados, activar recepción automáticamente
        if (!isConsolidated) {
          setActiveForm("reception");
        }
      }
    };

    loadInitialData();
  }, []);

  const handleFormClick = async (form) => {
    if (form === "reception") {
      // Si no hay datos de recepción cargados, cargarlos
      if (!receptionFormData && !isLoadingReceptionData) {
        await loadReceptionData();
      }
      setActiveForm(form);
    } else {
      setActiveForm(form);
    }
    setSelectedSubproduct(null);
  };

  const showForm = async (sub) => {
    const data = await loadReceptionData(sub?.id);
    if (data) {
      setSelectedSubproduct(sub);
      setActiveForm("reception");
    }
  };

  const renderForm = () => {
    switch (activeForm) {
      case "reception":
        if (isLoadingReceptionData) {
          return (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p className="mt-3">
                Cargando datos del formulario de recepción...
              </p>
            </div>
          );
        }

        if (!receptionFormData) {
          return (
            <div className="alert alert-warning text-center">
              <p>
                No se pudieron cargar los datos del formulario de recepción.
              </p>
              <button
                className="btn btn-primary btn-sm mt-2"
                onClick={() => loadReceptionData()}
              >
                Reintentar
              </button>
            </div>
          );
        }

        return (
          <ReceptionForm
            master={receptionFormData}
            subproduct={selectedSubproduct}
          />
        );

      case "review":
        return (
          <LoadReviewForm master={master} subproduct={selectedSubproduct} />
        );

      case "cubiscan":
        return (
          <CubiscanForm
            master={master}
            subproduct={selectedSubproduct}
            isConsolidated={isConsolidated}
          />
        );

      case "locations":
        return (
          <LocationsForm
            master={master}
            subproduct={selectedSubproduct}
            loading={loading}
            setLoading={setLoading}
          />
        );

      default:
        return;
    }
  };

  return (
    <div className="container-fluid">
      {/* Botones de navegación */}
      <div className="d-flex gap-3 mb-4 flex-wrap">
        <button
          onClick={() => handleFormClick("reception")}
          className={`btnn ${activeForm === "reception" ? "active" : ""}`}
          disabled={isLoadingReceptionData}
        >
          {isLoadingReceptionData ? "Cargando..." : "Recepción de documentos"}
        </button>
        <button
          onClick={() => handleFormClick("review")}
          className={`btnn ${activeForm === "review" ? "active" : ""}`}
        >
          Revisión de la carga
        </button>
        <button
          onClick={() => handleFormClick("cubiscan")}
          className={`btnn ${activeForm === "cubiscan" ? "active" : ""}`}
        >
          Cubiscan
        </button>
        <button
          onClick={() => handleFormClick("locations")}
          className={`btnn ${activeForm === "locations" ? "active" : ""}`}
        >
          Locaciones
        </button>
      </div>

      <div className="content-area">
        {activeForm === "locations" ? (
          <LocationsForm
            master={master}
            subproduct={selectedSubproduct}
            loading={loading}
            setLoading={setLoading}
          />
        ) : (
          <>
            {renderForm()}

            {isConsolidated && !selectedSubproduct && (
              <>
                <div className="mt-5">
                  <table
                    className="table"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <thead className="text-center">
                      <tr>
                        <th
                          style={{
                            backgroundColor: "#020C41",
                            color: "white",
                          }}
                        >
                          HBS
                        </th>
                        <th
                          style={{
                            backgroundColor: "#020C41",
                            color: "white",
                          }}
                        >
                          Fecha
                        </th>
                        <th
                          style={{
                            backgroundColor: "#020C41",
                            color: "white",
                          }}
                        >
                          Piezas
                        </th>
                        <th
                          style={{
                            backgroundColor: "#020C41",
                            color: "white",
                          }}
                        >
                          Peso
                        </th>
                        <th
                          style={{
                            backgroundColor: "#020C41",
                            color: "white",
                          }}
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {master.data?.map((sub, index) => (
                        <tr key={index}>
                          <td>{safeValue(sub.hbs, "N/A")}</td>
                          <td>{safeValue(sub.date, "N/A")}</td>
                          <td>{safeValue(sub.pieces, "N/A")}</td>
                          <td>{safeValue(sub.weight, "N/A")}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => showForm(sub)}
                              disabled={isLoadingReceptionData}
                            >
                              {isLoadingReceptionData ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "➜"
                              )}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {(!master.data || master.data.length === 0) && (
                    <div className="text-center mt-3">
                      <p className="text-muted">
                        No hay subproductos disponibles
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>

      {isLoadingReceptionData && (
        <div className="alert alert-info text-center mt-3">
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          Cargando datos del formulario...
        </div>
      )}

      {!master && (
        <div className="alert alert-warning text-center">
          No se encontraron datos del master. Por favor, regrese y busque
          nuevamente.
        </div>
      )}
    </div>
  );
}

export default FormsView;